import React, { useEffect, useRef, useState } from "react";

import { motion, AnimatePresence } from "motion/react";
import { ActionButtonFull } from "../component/buttons";

export const ChatMessageItem = ({ text }) => {
  return (
    <motion.div
      className="row-layout list-item"
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
      }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 1.0,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <p>{text}</p>
    </motion.div>
  );
};
const allMessages = [
  "You gave one artist the Ex Treatment this year",
  "You listened to them once",
  "then #ghosted for the rest of the year...",
  "...",
  "👻👻👻👻",
];

const ChatMessages = ({ data, next }) => {
  const [displayedMessages, setDisplayedMessages] = useState([]);
  const [showArtist, setShowArtist] = useState(false);
  const [showArtistName, setShowArtistName] = useState(false);
  const [showDate, setShowDate] = useState(false);
  const [showNextButton, setShowNextButton] = useState(false);

  const MESSAGE_DELAY = 1500;

  useEffect(() => {
    // Simulating messages being received dynamically
    allMessages.forEach((message, index) => {
      setTimeout(() => {
        setDisplayedMessages((prev) => [...prev, message]);
      }, index * MESSAGE_DELAY); // 500ms delay between each message
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShowArtist(true);
    }, allMessages.length * MESSAGE_DELAY + MESSAGE_DELAY);
  }, [showArtist]);

  useEffect(() => {
    setTimeout(() => {
      setShowArtistName(true);
    }, allMessages.length * MESSAGE_DELAY + MESSAGE_DELAY * 2);
  }, [showArtistName]);

  useEffect(() => {
    setTimeout(() => {
      setShowDate(true);
    }, allMessages.length * MESSAGE_DELAY + MESSAGE_DELAY * 3);
  }, [showDate]);

  useEffect(() => {
    setTimeout(() => {
      setShowNextButton(true);
    }, allMessages.length * MESSAGE_DELAY + MESSAGE_DELAY * 5);
  }, [showNextButton]);

  var artistName = null;
  if (data.artist_id && data.artist_id.name) {
    artistName = data.artist_id.name;
  }

  var artwork = null;
  if (data.artist_id && data.artist_id.artwork) {
    artwork = data.artist_id.artwork;
  }

  var dateString = null;
  if (data.played_at_date && data.played_at_date) {
    const date = new Date(data.played_at_date);
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    dateString = date.toLocaleDateString(undefined, options);
  }

  return (
    <div className="chat-container">
      <AnimatePresence>
        {displayedMessages.map((message, index) => (
          <motion.div
            key={message}
            className="message-bubble"
            initial={{ opacity: 0, translateY: 20 }}
            animate={{ opacity: 1, translateY: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            {message}
          </motion.div>
        ))}

        {showArtist && artwork && (
          <motion.div
            key="artist"
            className="artist-item-container-chat"
            initial={{ opacity: 0, translateY: 20 }}
            animate={{ opacity: 1, translateY: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <img
              referrerPolicy="no-referrer"
              src={artwork}
              alt=""
              className="artist-item-chat artist-capsule"
            />
          </motion.div>
        )}

        {showArtistName && artistName && (
          <motion.div
            key="artist-name"
            style={styles.messageBubble}
            initial={{ opacity: 0, translateY: 20 }}
            animate={{ opacity: 1, translateY: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            {artistName}
          </motion.div>
        )}

        {showDate && (
          <motion.div
            key="date"
            className="message-bubble message-bubble-date"
            initial={{ opacity: 0, translateY: 20 }}
            animate={{ opacity: 1, translateY: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <img
              src={require("../assets/img/check-read-outline.svg")}
              alt="read"
            />
            <p>Read - {dateString}</p>
          </motion.div>
        )}

        {showNextButton && (
          <motion.div
            key="next"
            className="message-bubble message-bubble-nobackground"
            initial={{ opacity: 0, translateY: 20 }}
            animate={{ opacity: 1, translateY: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <button
              onClick={() => {
                next();
              }}
            >
              <ActionButtonFull title="next" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ChatMessages;

const styles = {
  messageBubble: {
    alignSelf: "flex-start",
    backgroundColor: "#007bff",
    color: "white",
    padding: "10px",
    borderRadius: "15px",
    maxWidth: "80%",
  },
};
